import { useState } from 'react';

import { useDispatch, useSelector } from 'hooks';
import { deletePlanGroup, savePlanGroup } from 'redux/actionCreators';

import { PlanGroup } from 'components/types';

import IconButton from '@mui/material/IconButton';
import ListItemText from '@mui/material/ListItemText';
import TextField from '@mui/material/TextField';

import { ListItemButton } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

export type PlanGroupType = Omit<PlanGroup, 'uniqId' | 'id'> & {
  isNew?: boolean;
  id: string | number;
};

type Props = {
  planGroup: PlanGroupType;
} & (
  | {
      isSelected: true;
    }
  | {
      isSelected: false;
      onSelected: (planGroup: PlanGroupType) => void;
    }
);

export default function PlanGroupComponent(props: Props) {
  const { planGroup, isSelected } = props;
  const dispatch = useDispatch();
  const planGroups = useSelector((state) => state.planGroups);
  const { name, id, isNew } = planGroup;
  const [newName, setNewName] = useState<string>(name);
  const [isInvalidName, setIsInvalidName] = useState<boolean>(false);

  const onNameChanged = (e) => {
    const { value } = e.target;
    const plangGroups = planGroups.filter(({ id }) => id !== planGroup.id);
    setIsInvalidName(plangGroups.some(({ name }) => name === value));
    setNewName(e.target.value);
  };

  return (
    <div className="d-flex item">
      {isSelected === true ? (
        <>
          <ListItemButton dense selected>
            <Icon type="folder" className="has-icon" />

            <TextField
              defaultValue={planGroup.name}
              error={isInvalidName}
              onChange={onNameChanged}
            />
          </ListItemButton>
          <IconButton
            color="primary"
            disabled={
              isInvalidName ||
              (planGroup.name === newName && !isNew) ||
              !newName
            }
            onClick={() => {
              dispatch(
                savePlanGroup({
                  isNew,
                  id,
                  name: newName || planGroup.name,
                  costCenters: planGroup.costCenters.slice()
                })
              );
            }}
            size="large"
          >
            <Icon type="download" />
          </IconButton>
        </>
      ) : (
        <>
          <ListItemButton dense onClick={() => props.onSelected(planGroup)}>
            <Icon type="folder" className="has-icon" />
            <ListItemText primary={planGroup.name} />
          </ListItemButton>
          <IconButton
            color="primary"
            onClick={() => {
              dispatch(deletePlanGroup(id));
            }}
            size="large"
          >
            <Icon type="xmark" />
          </IconButton>
        </>
      )}
    </div>
  );
}
